// extracted by mini-css-extract-plugin
module.exports = {"sort-btntxt":"Sort_sort-btntxt__j_bAR","sortBtntxt":"Sort_sort-btntxt__j_bAR","asc":"Sort_asc__dWj0n","desc":"Sort_desc__y0jdm"};